import SocketConnect from "game_play/utils/socket";

export const STATUS_TEXT = {
  'competed': gettext('Завершён'),
  'live': gettext('Турнир идёт'),
  'preparation': gettext('Идет набор'),
  'registration': gettext('Регистрация'),
  'ready': gettext('Набор завершён')
}

export function toRequestDate(date) {
  if (!date) return null
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

class Tournaments extends SocketConnect {
  constructor(ctx, data, urls = window.URLS) {
    super(ctx, urls.ws, urls.tournaments);

    this.set('tournaments', data)
  }

  afterFetch(data) {
    this.set('tournaments', [...data]);
  }

  afterSave(data) {
    this.set('tournaments', this.get('tournaments').map(tournament => {
      if (tournament.id === data.id) {
        return data
      }
      return tournament
    }))
  }

  afterDelete(id) {
    this.deleteItem(id)
  }

  optimisticDelete(id) {
    this.deleteItem(id)
  }

  onSocket(event) {
    super.onSocket();

    switch (event.type) {
      case "update":
        let newTournaments = event.message
        const tournaments = this.get('tournaments');
        tournaments.forEach((tournament, i) => {
          newTournaments = newTournaments.filter((_tournament) => {
            if (tournament.id === _tournament.id) {
              tournaments[i] = _tournament
              return false
            }
            return true
          })
        })
        this.set('tournaments', [...tournaments, ...newTournaments]);

        break;
      case "delete":
        let ids = event.message
        this.set('tournaments', this.get('tournaments').filter(tournaments => {
          return !ids.includes(tournaments.id)
        }));
        break;
      default:
    }
  }

  async start(tournament) {
    const data = await this.request({
      url: `${tournament.detail_url}start/`,
      method: 'POST',
    })
    this.afterSave(data)
  }

  async finish(tournament) {
    const data = await this.request({
      url: `${tournament.detail_url}finish/`,
      method: 'POST',
    })
    this.afterSave(data)
  }

  async reset(tournament) {
    const data = await this.request({
      url: `${tournament.detail_url}reset/`,
      method: 'POST',
    })
    this.afterSave(data)
  }

  deleteItem(id) {
    this.set('tournaments', this.get('tournaments').filter(tournament => tournament.id !== id));
  }

  isLive(tournament) {
    return tournament.games.some((game) => game.live)
  }

  getStatus(tournament) {
    if (tournament.completed) {
      return 'competed'
    }
    if (this.isLive(tournament)) {
      return 'live'
    }
    if (tournament.games?.length) {
      return 'ready'
    }
    if (tournament.allow_requests) {
      return 'registration'
    }
    return 'preparation'
  }

  getStatusText(tournament) {
    return STATUS_TEXT[this.getStatus(tournament)]
  }

  getTypeDisplay(tournament) {
    return tournament.type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
  }
}

export default Tournaments